import { Box } from '@mantine/core';
import cx from 'clsx';
import { ReactNode } from 'react';

import classes from './DirectionWrapper.module.scss';

type DirectionWrapperProps = {
  direction: 'ltr' | 'rtl';
  children: ReactNode;
  className?: string;
};

export function DirectionWrapper(props: DirectionWrapperProps) {
  const { children, direction, className } = props;

  return (
    <Box className={cx(classes.directionOverride, className)} style={{ '--direction': direction }}>
      {children}
    </Box>
  );
}
